<ng-container>
  <p-table
    #dt
    [value]="awsEventLogs"
    [globalFilterFields]="['srcIp', 'srcPort', 'destIp', 'destPort', 'proto', 'action', 'sni']"
    dataKey="flowId"
    [scrollable]="true"
    [scrollHeight]="scrollHeight"
    [tableStyle]="{ 'min-width': '40rem' }"
    [styleClass]="'p-datatable-sm aws-fwlogs-datatable'"
    [rowHover]="true"
    selectionMode="none"
  >
    <ng-template pTemplate="caption">
      <div class="caption-container">
        <div class="panel-title flex-row">
          <p-iconfield class="filter-container">
            <input pInputText #filterInput type="text" (keydown)="onKeyDown($event)" placeholder="Filter events..." />
            <p-inputicon *ngIf="!isFilterApplied && !loading" class="fa-utility-fill fa-semibold fa-filter fade-icon" />
            <p-inputicon
              *ngIf="isFilterApplied && !loading"
              (click)="clearFilter()"
              class="fa-utility fa-semibold fa-xmark"
            />
            <p-inputicon *ngIf="loading" class="fa-solid fa-spinner fa-spin" />
          </p-iconfield>
        </div>

        <div class="flex-row">
          <p-select
            (onChange)="fetchLogs($event.value)"
            [options]="timeOptions"
            [(ngModel)]="timeSelected"
            placeholder="Select Time Range:"
            optionLabel="label"
            dataKey="value"
          ></p-select>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="timestamp" class="strong-text whitespace-nowrap">
          Timestamp <p-sortIcon field="timestamp"></p-sortIcon>
        </th>
        <th pSortableColumn="srcIp" class="strong-text whitespace-nowrap">
          Source IP <p-sortIcon field="srcIp"></p-sortIcon>
        </th>
        <th pSortableColumn="srcPort" class="strong-text whitespace-nowrap">
          Source Port <p-sortIcon field="srcPort"></p-sortIcon>
        </th>
        <th pSortableColumn="destIp" class="strong-text whitespace-nowrap">
          Destination IP <p-sortIcon field="destIp"></p-sortIcon>
        </th>
        <th pSortableColumn="destPort" class="strong-text whitespace-nowrap">
          Destination Port <p-sortIcon field="destPort"></p-sortIcon>
        </th>
        <th pSortableColumn="proto" class="strong-text whitespace-nowrap">
          Protocol <p-sortIcon field="proto"></p-sortIcon>
        </th>
        <th pSortableColumn="action" class="strong-text whitespace-nowrap">
          Action <p-sortIcon field="action"></p-sortIcon>
        </th>
        <th pSortableColumn="sni" class="strong-text whitespace-nowrap">SNI <p-sortIcon field="sni"></p-sortIcon></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-log>
      <tr>
        <td>{{ log.timestamp.toISOString() }}</td>
        <td>{{ log.srcIp }}</td>
        <td>{{ log.srcPort }}</td>
        <td>{{ log.destIp }}</td>
        <td>{{ log.destPort }}</td>
        <td>{{ log.proto }}</td>
        <td>{{ log.action }}</td>
        <td>{{ log.sni }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center default-padding loading-text">
          <ng-container *ngIf="loading"> <i class="fa-solid fa-spinner fa-spin"></i> Loading events... </ng-container>
          <ng-container *ngIf="!loading"> No events found. </ng-container>
        </td>
      </tr>
    </ng-template>

    <!-- Table Summary -->
    <ng-template pTemplate="summary">
      <div class="flex gap-2 align-items-center justify-content-between">
        <ng-container *ngIf="loading">
          <div>Loading ...</div>
        </ng-container>
        <ng-container *ngIf="errorMessage && !loading">
          {{ errorMessage }} <a (click)="fetchLogs()">Click here to refresh</a>
        </ng-container>
      </div>
    </ng-template>
  </p-table>
</ng-container>

<div *ngIf="awsConsoleUrl" class="margin-top margin-left">
  <a [href]="awsConsoleUrl" target="_blank">View events in CloudWatch</a>
</div>
